import { getAssociations } from "src/hooks/be";

export const hasAssociatedProvider = async (
  globoId: string,
  providerId: string
): Promise<boolean> => {
  const associations = await getAssociations(globoId);
  const hasAssociated = associations.find(association => {
    return association.providerID === providerId;
  });

  return hasAssociated !== undefined;
};
